import { render } from "./MyRestaurants.vue?vue&type=template&id=e23569fa"
import script from "./MyRestaurants.vue?vue&type=script&lang=js"
export * from "./MyRestaurants.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__